import {router} from '@/router'
import { showToast } from 'vant'
import  TonConnectUI from '@tonconnect/ui'
import TonConnect from '@tonconnect/sdk';

export const connector = new TonConnect({
    manifestUrl: 'https://root.usdtshequ.com/src/tonconnect-manifest.json'
});

//  const tonConnectUI = new TonConnectUI({
//     manifestUrl: 'https://root.usdtshequ.com/src/tonconnect-manifest.json',
//     // buttonRootId: '<YOUR_CONNECT_BUTTON_ANCHOR_ID>',
//     // uiPreferences: {
//     //  language: "zh-Cn"
//     // }
// });




export function _isMobile() {      
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)      
    return flag;    
}
export function isPhoneNumber(str) {
    var myreg = /^\d+$/;
    if (!myreg.test(str)) {
        return false;
    } else {
        return true;
    }
}

export function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

export function starPhone(phoneNum){
    let str = String(phoneNum),
        strLen = str.slice(0, 3) +'****' + str.slice(str.length-4);
    return strLen;
}


export function goLink(url,query){
    router.push({
        path:url,
        query:query
    })
}

export function toToast(msg){
    showToast(msg)
}

export function getformToken(str){
    if(str){
        return str.substr(0,3)+'...'+str.substr(str.length-3)
    }else{
        return str
    }
  }
  export function getformAddr(str){
    if(str){
        return str.substr(0,6)+'...'+str.substr(str.length-6)
    }else{
        return str
    }
  }


export function openUrl(url) {
    let openInBrowser = (url) => {
        if (window.android) {
            window.android.callAndroid("open," + url)
            return;
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeExt) {
            window.webkit.messageHandlers.nativeExt.postMessage({ msg: 'open,' + url })
            return;
        }
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
            window.location.href = url;
            return;
        }
        window.open(url)
    }
    openInBrowser(url);
    return
  }